import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface CertificateItemProps {
  title: string
  date?: string | null
  isLocked?: boolean
  badgeSrcKey: string
  subtitle?: string
}

export default function CertificateItem({
  title,
  isLocked,
  badgeSrcKey,
  subtitle,
}: CertificateItemProps): React.ReactElement {
  return (
    <div className="flex w-22 lg:w-36 flex-col items-center gap-2 opacity-90 hover:opacity-100 transition-opacity cursor-pointer">
      <div className={`w-20 h-14 flex items-center justify-center relative ${isLocked ? 'grayscale' : ''}`}>
        <ResponsiveImage
          alt="Certificate"
          fit="contain"
          height={1080}
          imageClassName="w-16 md:w-17"
          srcKey={badgeSrcKey}
          width={1080}
        />
      </div>
      <div className="flex flex-col items-center">
        <span className="text-white text-xxs lg:text-xs font-bold text-center">{title}</span>
        {subtitle && <span className="text-white/60 text-xxs font-bold text-center">{subtitle}</span>}
      </div>
    </div>
  )
}
